import { TCreative } from "./creative";
import { CREATIVE_TYPES } from "./creativeTypes";

export type PrimaryTypeLabel = "Video" | "Banner" | "Dynamic HTML5" | "Native";

export const PRIMARY_TYPE_LABELS: PrimaryTypeLabel[] = [
  "Banner",
  "Video",
  "Dynamic HTML5",
  "Native",
];

export function getPrimaryTypeLabel(creative: TCreative): PrimaryTypeLabel {
  if (creative.creativeType === CREATIVE_TYPES.NATIVE) {
    return "Native";
  }
  if (
    creative.creativeType === CREATIVE_TYPES.VIDEO_VAST ||
    creative.creativeType === CREATIVE_TYPES.VIDEO_VAST_HTML_EC
  ) {
    return "Video";
  }
  // RICH_MEDIA: distinguish Banner vs Dynamic HTML5 by presence of playableId
  if ((creative as any).playableId) {
    return "Dynamic HTML5";
  }
  return "Banner";
}

// Secondary label placeholder — to be implemented later
export function getSecondaryTypeLabel(_creative: TCreative): string {
  return "label2";
}
